/**
 * 创建人：zll
 * 时间：2019-04-19
 * 描述：表格列筛选组件
 * 使用说明: 参考 sw-filter 配置应用说明文档
 * 更新记录: 
 */
import { Component, OnInit, Input,Output,EventEmitter,AfterViewInit,HostListener, ElementRef} from '@angular/core';
declare var $: any;


/**
 * 表格列筛选组件 sw-filter
 */
@Component({
  selector: 'sw-filter',
  templateUrl: './sw-filter.component.html',
  styleUrls: ['./sw-filter.component.css']
})
export class SwFilterComponent implements OnInit,AfterViewInit {
  /**
   * 打开筛选数据
   * @ignore
   */
  drownDown:boolean= false;

  /**
   * 下拉树组 {} 筛选checkbox判断
   */
  @Input() filterDatas: any = {};  

  /**
   * {id:"",text:""} 筛选dropdown数据
   */
  @Input() filterDatasArray:any[] =[] 

  /**
   * 选中筛选数据
   */
  @Output() filter =  new EventEmitter();


  /**
   * @ignore
   */
  constructor(private _elementRef: ElementRef) { }

  /**
   * @ignore
   */
  ngOnInit() {
  }

  /**
   * @ignore
   */
  ngAfterViewInit() {
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    const clickInside = this._elementRef.nativeElement.contains(targetElement)
    if(!clickInside) {
      this.drownDown = false
    }
    
  }
  /**
   * 打开筛选数据
   * @ignore
   */
  open() {
    this.drownDown = !this.drownDown;
  }

  /**
   * 选中数据
   * @param value 选中的id 
   * @ignore
   */
  isChecked(value) {
     return this.filterDatas[value]
  }
  
  /**
   * 抛出点击事件
   * @param value 
   * @ignore
   */
  filterData(value) {
    this.filterDatas[value] = !this.filterDatas[value];
    this.filter.emit(this.filterDatas)
  }


}
